(function () {
  'use strict';

  var requestState = new WeakMap();
  var productCache = new WeakMap();
  var sectionCache = new WeakMap();
  var displayStates = new WeakMap();

  // Keep nested complementary products isolated from the main product.
  function ownedNodes(root, selector) {
    return Array.from(root.querySelectorAll(selector)).filter(function (node) {
      return node.closest('xo-product[xo-product-information]') === root;
    });
  }

  function syncDisplay(productRoot, variant, changeMedia) {
    if (!variant) {
      ownedNodes(productRoot, 'xo-cart-add button, .shopify-payment-button__button').forEach(function (button) { button.disabled = true; });
      return;
    }
    var data = parseProductData(productRoot);
    var productId = productRoot.getAttribute('xo-product-id');
    var priceHtml = data && data.instant_prices && data.instant_prices[String(variant.id)];
    if (priceHtml && !variant.unit_price_measurement) {
      var holder = document.createElement('div');
      holder.innerHTML = priceHtml;
      var source = holder.querySelector('.xo-price__container');
      nodesWithUniqueId(productRoot, 'product-price-' + productId).forEach(function (node) {
        var target = node.querySelector('.xo-price__container');
        if (target && source && target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
      });
    }
    (data.options || []).forEach(function (name, index) {
      nodesWithUniqueId(productRoot, 'product-variant-' + name + '-' + productId).forEach(function (node) {
        if (node.textContent.trim() !== variant.options[index]) node.textContent = variant.options[index];
      });
    });
    (data.options || []).forEach(function (name, index) {
      ownedNodes(productRoot, '.sticky-addcart-desktop xo-product-variant-selected').forEach(function (label) {
        if (label.getAttribute('xo-name') === name && label.textContent.trim() !== variant.options[index]) label.textContent = variant.options[index];
      });
      ownedNodes(productRoot, '.sticky-addcart__variants-wrap input, .sticky-addcart__variants-wrap select').forEach(function (input) {
        if (input.name.replace('[STICKY_FIELD_SIGNAL]', '') === name) {
          if (input.tagName === 'SELECT') {
            input.value = variant.options[index];
            Array.from(input.options).forEach(function (option) {
              option.disabled = !data.variants.some(function (candidate) {
                return candidate.available && candidate.options.every(function (value, optionIndex) {
                  return value === (optionIndex === index ? option.value : variant.options[optionIndex]);
                });
              });
            });
          }
          else input.checked = input.value === variant.options[index];
        }
      });
    });
    setVariantIds(productRoot, variant.id);
    ownedNodes(productRoot, 'xo-cart-add button').forEach(function (button) {
      button.disabled = !variant.available;
      var text = button.querySelector('.xo-btn__text');
      var strings = window.variantStrings || {};
      var label = variant.available ? strings.addToCart : strings.soldOut;
      if (text && label && text.textContent.trim() !== label) {
        text.textContent = label;
        text.setAttribute('data-text', label);
      }
    });
    ownedNodes(productRoot, '.shopify-payment-button__button').forEach(function (button) { button.disabled = !variant.available; button.setAttribute('aria-disabled', String(!variant.available)); });
    if (changeMedia && variant.featured_media) {
      ownedNodes(productRoot, 'xo-carousel[xo-name*="product-information-"]').forEach(function (carousel) {
        if (carousel.closest('xo-carousel-thumbnail')) return;
        var slides = Array.from(carousel.querySelectorAll('xo-carousel-slide[data-media-id]:not([xo-cloned])'));
        var index = slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === String(variant.featured_media.id); });
        if (index < 0) return;
        slides[index].querySelectorAll('img').forEach(function (image) { image.loading = 'eager'; image.setAttribute('fetchpriority', 'high'); });
        if (window.xoCarousel && typeof window.xoCarousel.goTo === 'function') window.xoCarousel.goTo(carousel.getAttribute('xo-name'), index);
      });
    }
  }

  function watchDisplay(productRoot) {
    if (displayStates.has(productRoot)) return;
    var state = { queued: false };
    displayStates.set(productRoot, state);
    var observer = new MutationObserver(function (mutations) {
      var carouselReady = mutations.some(function (mutation) { return mutation.type === 'attributes' && mutation.target.hasAttribute('xo-initialized') && mutation.target.closest('xo-product[xo-product-information]') === productRoot; });
      if (carouselReady && !state.changed) window.requestAnimationFrame(function () { if (productRoot.isConnected && !state.changed) syncDisplay(productRoot, findVariant(productRoot), true); });
      var relevant = mutations.some(function (mutation) {
        var element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return element && element.closest('xo-product[xo-product-information]') === productRoot && (element.closest('xo-product-will-change') || element.closest('.xo-product-info-content__variants'));
      });
      if (!relevant || state.queued) return;
      state.queued = true;
      window.queueMicrotask(function () {
        state.queued = false;
        if (productRoot.isConnected) syncDisplay(productRoot, findVariant(productRoot), false);
      });
    });
    observer.observe(productRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['xo-initialized'] });
    state.observer = observer;
  }


  function updateVariantTooltips(root) {
    var scope = root || document;
    var labels = scope.querySelectorAll('.main-product__right .xo-product-info-content__variants .xo-field-radio--boxed2[data-variant-tooltip]');

    Array.prototype.forEach.call(labels, function (label) {
      var text = label.querySelector('.xo-field-radio__label > span');
      if (!text) return;

      var isOverflowing = text.scrollWidth > text.clientWidth + 1;
      if (isOverflowing) {
        label.setAttribute('data-option-overflow', '');
      } else {
        label.removeAttribute('data-option-overflow');
      }
    });
  }

  function parseProductData(productRoot) {
    var script = ownedNodes(productRoot, 'xo-product-data script[type="application/json"]')[0];
    if (!script) return null;

    var cached = productCache.get(productRoot);
    if (cached && cached.script === script && cached.text === script.textContent) return cached.data;
    try {
      var data = JSON.parse(script.textContent.replace(/,\s*([}\]])/g, '$1'));
      productCache.set(productRoot, { script: script, text: script.textContent, data: data });
      return data;
    } catch (error) {
      console.error('[PDP variant sync] Invalid product data.', error);
      return null;
    }
  }

  function selectedOptions(productRoot) {
    var container = ownedNodes(productRoot, '.xo-product-info-content__variants')[0];
    if (!container) return [];

    var controls = Array.prototype.slice.call(container.querySelectorAll('input[name], select[name]'));
    var names = [];

    controls.forEach(function (control) {
      if (names.indexOf(control.name) === -1) names.push(control.name);
    });

    return names.map(function (name) {
      var matching = controls.filter(function (control) {
        return control.name === name;
      });
      var selected = matching.filter(function (control) {
        return control.tagName === 'SELECT' || control.checked;
      })[0];
      return selected ? selected.value : null;
    });
  }

  function findVariant(productRoot) {
    var data = parseProductData(productRoot);
    if (!data || !Array.isArray(data.variants)) return null;

    var options = selectedOptions(productRoot);
    if (!options.length) return data.variants.length === 1 ? data.variants[0] : null;
    if (options.indexOf(null) !== -1) return null;

    return data.variants.filter(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (value, index) {
        return value === options[index];
      });
    })[0] || null;
  }

  function setVariantIds(productRoot, variantId) {
    // The native add component reads this on click, independently of the section response.
    ownedNodes(productRoot, '.main-product__right xo-cart-add, .sticky-addcart-desktop xo-cart-add').forEach(function (add) {
      if (add.getAttribute('xo-variant-id') !== String(variantId)) add.setAttribute('xo-variant-id', String(variantId));
    });
    Array.prototype.forEach.call(ownedNodes(productRoot, 'form[action*="/cart/add"] input[name="id"]'), function (input) {
      input.value = String(variantId);
      input.setAttribute('value', String(variantId));
    });
  }

  function copyAttributes(target, source) {
    Array.prototype.slice.call(target.attributes).forEach(function (attribute) {
      target.removeAttribute(attribute.name);
    });
    Array.prototype.slice.call(source.attributes).forEach(function (attribute) {
      target.setAttribute(attribute.name, attribute.value);
    });
  }

  function nodesWithUniqueId(root, id) {
    return Array.prototype.filter.call(root.querySelectorAll('xo-product-will-change[xo-unique-id]'), function (node) {
      return node.closest('xo-product[xo-product-information]') === root && node.getAttribute('xo-unique-id') === id;
    });
  }

  function applySectionResponse(productRoot, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var productId = productRoot.getAttribute('xo-product-id');
    var sourceRoot = parsed.querySelector('xo-product[xo-product-information][xo-product-id="' + productId + '"]');
    if (!sourceRoot) return false;

    var ids = [];
    Array.prototype.forEach.call(ownedNodes(productRoot, 'xo-product-will-change[xo-unique-id]'), function (node) {
      var id = node.getAttribute('xo-unique-id');
      if (ids.indexOf(id) === -1) ids.push(id);
    });

    ids.forEach(function (id) {
      var currentNodes = nodesWithUniqueId(productRoot, id);
      var sourceNodes = nodesWithUniqueId(sourceRoot, id);
      if (!sourceNodes.length) return;

      currentNodes.forEach(function (currentNode, index) {
        var sourceNode = sourceNodes[Math.min(index, sourceNodes.length - 1)];
        copyAttributes(currentNode, sourceNode);
        currentNode.innerHTML = sourceNode.innerHTML;
      });
    });

    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
    updateVariantTooltips(productRoot);
    return true;
  }

  function sectionUrl(productRoot, variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', productRoot.getAttribute('xo-section-id'));
    return url.pathname + '?' + url.searchParams.toString();
  }

  function updateBrowserUrl(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('section_id');
    window.history.replaceState({}, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
  }

  function refreshVariant(productRoot) {
    var variant = findVariant(productRoot);
    var previous = requestState.get(productRoot);
    if (previous) previous.abort();
    watchDisplay(productRoot);
    displayStates.get(productRoot).changed = true;
    displayStates.get(productRoot).pending = !!variant;
    syncDisplay(productRoot, variant, true);
    if (!variant) return;
    updateBrowserUrl(variant.id);
    var controller = new AbortController();
    requestState.set(productRoot, controller);
    var cache = sectionCache.get(productRoot);
    if (!cache) { cache = new Map(); sectionCache.set(productRoot, cache); }
    var request = cache.has(variant.id) ? Promise.resolve(cache.get(variant.id)) : fetch(sectionUrl(productRoot, variant.id), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Section request failed: ' + response.status);
      return response.text();
    });
    request.then(function (html) {
      if (requestState.get(productRoot) !== controller || !productRoot.isConnected) return;
      var current = findVariant(productRoot);
      if (!current || current.id !== variant.id) return;
      displayStates.get(productRoot).pending = false;
      cache.set(variant.id, html);
      if (cache.size > 20) cache.delete(cache.keys().next().value);
      if (!applySectionResponse(productRoot, html)) throw new Error('Product section was not found in the response.');
      syncDisplay(productRoot, current, false);
    }).catch(function (error) {
      if (requestState.get(productRoot) === controller) {
        displayStates.get(productRoot).pending = false;
        syncDisplay(productRoot, findVariant(productRoot), false);
      }
      if (error.name !== 'AbortError') console.error('[PDP variant sync]', error);
    });
  }

  document.addEventListener('change', function (event) {
    var stickyVariants = event.target.closest('.sticky-addcart__variants-wrap');
    if (stickyVariants) {
      var stickyRoot = stickyVariants.closest('xo-product[xo-product-information]');
      var mainVariants = stickyRoot && stickyRoot.querySelector('.xo-product-info-content__variants');
      if (!mainVariants) return;
      var optionName = event.target.name.replace('[STICKY_FIELD_SIGNAL]', '');
      var mainControl = Array.from(mainVariants.querySelectorAll('input[name], select[name]')).find(function (input) {
        return input.name.replace(/^\[SIGNAL_[^\]]+\]/, '') === optionName && (input.tagName === 'SELECT' || input.value === event.target.value);
      });
      if (!mainControl) return;
      event.stopImmediatePropagation();
      if (mainControl.tagName === 'SELECT') mainControl.value = event.target.value;
      else mainControl.checked = true;
      mainControl.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var variants = event.target.closest('.xo-product-info-content__variants');
    if (!variants) return;

    var productRoot = variants.closest('xo-product[xo-product-information]');
    if (!productRoot) return;

    refreshVariant(productRoot);
  }, true);


  document.addEventListener('click', function (event) {
    var add = event.target.closest('.main-product__right xo-cart-add, .sticky-addcart-desktop xo-cart-add');
    var productRoot = add && add.closest('xo-product[xo-product-information]');
    if (!productRoot) return;
    var variant = findVariant(productRoot);
    if (!variant || !variant.available || add.hasAttribute('xo-loading')) {
      event.preventDefault();event.stopImmediatePropagation();return;
    }
    setVariantIds(productRoot, variant.id);
  }, true);

  function initializeDisplay(root) {
    (root || document).querySelectorAll('xo-product[xo-product-information]').forEach(function (productRoot) {
      var data = parseProductData(productRoot);
      if (!data || !data.instant_prices || !Object.keys(data.instant_prices).length) return;
      watchDisplay(productRoot);
      syncDisplay(productRoot, findVariant(productRoot), true);
      if (window.customElements) window.customElements.whenDefined('xo-carousel').then(function () {
        window.requestAnimationFrame(function () { if (productRoot.isConnected) syncDisplay(productRoot, findVariant(productRoot), true); });
      });
    });
  }

  var resizeFrame = null;
  window.addEventListener('resize', function () {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      updateVariantTooltips(document);
      resizeFrame = null;
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    updateVariantTooltips(event.target);
    initializeDisplay(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateVariantTooltips(document);
      initializeDisplay(document);
    });
  } else {
    updateVariantTooltips(document);
    initializeDisplay(document);
  }
})();
